<template>
  <div v-show="isReady" class="form-page_paylands">
    <div class="paylands-ask" v-if="!paylandsShowed">
      <h2>Verificación por tarjeta de crédito</h2>
      Tu tarjeta de crédito es un factor esencial para conseguir una oferta de préstamo. Esta información resulta fundamental para garantizar un proceso seguro y evitar fraudes acerca de tu identidad.
      No se realizará ningún cargo durante este proceso de evaluación. La tarjeta puede ser usada posteriormente para pagar el préstamo. La información relativa a la tarjeta es confidencial, segura y no será compartida con terceros.
      <button class="form-buttons__next" @click="paylandsShowed = true">
        VERIFICACIÓN POR TARJETA
      </button>
      <div class="paylands-ask__skip"><a @click="skipPaylands">NO TENGO TARJETA DE CRÉDITO</a></div>
    </div>
    <transition name="paylands">
      <div v-show="paylandsShowed">
        <div class="tooltip" v-if="history[currentStep].field.tooltip">
          <span class="icon icon-info-line"><info-icon/></span>
          <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
          </p>
        </div>
        <div id="paylands-container"><iframe id="pl"></iframe></div>
        <div v-if="!paylandsRequired" class="has_declined_paylands_shower"><a id="has_declined_paylands" @click="skipPaylands">NO TENGO TARJETA DE CRÉDITO</a><br></div>
      </div>
    </transition>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
import Crezu from '@/utils/'


export default {
  name: 'Paylands',
  components: { InfoIcon },
  data () {
    return {
      paylandsShowed: false,
      inputVal: null,
      paylandsRequired: window.paylands_required || 0, // written in Confirm step for Moneyman
      isReady: false,
    }
  },
  computed: {
    isValid () {
      let regex = new RegExp(this.history[this.currentStep].field.reg)
      return regex.test(this.inputVal)
    },
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      config: state => state.config,
      isDev: state => state.isDev
    })
  },
  mounted () {
    let parsedData = { paylands_customer_token: 'error', unnax_url: 'error', online_banking_id: 'error' }
    // TODO: delete moneyman additional
    this.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_paylands', sub3: 'moneyman_paylands_inited' } })
    this.$store.dispatch('pushGAEvent', 'paylandsInit')
    this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { paylands_provided: false, paylands_required: this.paylandsRequired })
    this.$store.dispatch('getCustomerToken', 'moneyman_paylands').then((data) => {
      console.log('GOT TOKEN', data)
      try {
        if (data.indexOf('"contract":') > -1) {
          // fix if backend send contract not on step with Confirm
          this.skipPaylands()
          return
        }
      } catch (e) {}
      try { parsedData = JSON.parse(data) } catch (e) {}
      localStorage.setItem('unnax_url', parsedData.unnax_url)
      this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { online_banking_id: parsedData.online_banking_id })
      // TODO: delete moneyman additional
      this.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_paylands', sub3: 'moneyman_paylands_token_got' } })

      if (!this.paylandsRequired) {
        this.skipPaylands()
      }

      this.initializePaylands(parsedData.paylands_customer_token)
      this.isReady = true
    }, (error) => {
      // TODO: delete moneyman additional
      this.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_paylands', sub3: 'moneyman_paylands_token_error' } })
      this.skipPaylands()
    })
  },
  watch: {
    inputVal: function (val) {
      if (!this.initValue) { this.initValue = true; return }
      this.$store.commit('UPDATE_FIELD', { isValid: this.isValid, val: val })
    }
  },
  methods: {
    initializePaylands (token) {
      console.log('token:', token)
      let sandboxPrefix = this.isDev ? '/sandbox' : ''
      document.getElementById('pl').src = `https://ws-paylands.paynopain.com/v1${sandboxPrefix}/payment/process/${token}`
      let vm = this
      window.addEventListener('message', function (e) {
        switch (e.data) {
          case 'PAYLANDS-SUCCESS':
            vm.$store.dispatch('pushGAEvent', 'paylandsComplete')
            vm.$store.commit('UPDATE_FIELD', { isValid: true })
            vm.$store.commit('CHANGE_ADDITIONAL_PARAMS', { paylands_provided: true })
            vm.$store.dispatch('nextStepPrepare', +1)

            // TODO: delete moneyman additional
            vm.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_paylands', sub3: 'moneyman_paylands_completed' } })
            break
          case 'PAYLANDS-ERROR':
            // todo: show error message, request
            console.log('PROCESS ERROR')
            vm.skipPaylands()

            // TODO: delete moneyman additional
            vm.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_paylands', sub3: 'moneyman_paylands_validation' } })
            break
        }
      })
    },
    skipPaylands () {
      this.$store.dispatch('pushGAEvent', 'paylandsSkip')
      this.$store.commit('UPDATE_FIELD', { isValid: true })
      this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { paylands_provided: false })
      this.$store.dispatch('nextStepPrepare', +1)

      // TODO: delete moneyman additional
      this.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_paylands', sub3: 'moneyman_paylands_skip' } })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/paylands";
  .paylands-enter-active, .paylands-leave-active {
    transition: opacity 1s;
  }
  .paylands-enter, .paylands-leave-to{
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/fields/Paylands.vue